// extracted by mini-css-extract-plugin
export var black = "_3d-6";
export var brand = "_3d-1";
export var ddefault = "_3d-0";
export var error = "_3d-3";
export var gray = "_3d-2";
export var highContrast = "_3d-8";
export var outline = "_3d-7";
export var success = "_3d-5";
export var warning = "_3d-4";